import { useEffect } from 'react';
import { useRustyState } from '@/state';

const REFRESH_MS = 60_000;

/** Unread and problem counts and the balance for the sidebar: on mount, then every minute while the tab is visible. */
export function useNavCounts() {
  useEffect(() => {
    const { refreshUnreadCount, refreshProblemsCount, refreshAccountBalance } =
      useRustyState.getState();
    const refresh = () => {
      if (document.visibilityState === 'hidden') return;
      void refreshUnreadCount();
      void refreshProblemsCount();
      void refreshAccountBalance();
    };

    refresh();
    void useRustyState
      .getState()
      .getAndSetCurrentSubscription()
      .catch(() => undefined);

    const timer = window.setInterval(refresh, REFRESH_MS);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, []);
}
